// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"130":"628d0f199b0686559a2e","3406":"1c77f36687c99a23ed45","9860":"dc9dd0cf3c65e86757f0"}[chunkId] + ".css";
};